import "./preference-editor.component.less"
import PreferenceEditorTpl from "./preference-editor.template.tpl"

import { PreferenceEditorComponent } from "./preference-editor.component";
import { RestfulAccessorProvider } from "@core/data-access/restful";
import { QpMessageDialogProvider } from "@qpUIs/qp-message-dialog/qp-message-dialog.provider";
import { PreferenceEditorService } from "./preference-editor.service";
import { WebsiteCurrencyRestService } from "@modules/website/rest/currency/website-currency-rest.service";
import { WebSiteCurrencyServiceConfig } from "@modules/website/rest/currency/website-currency-rest.config";

let preferenceEditorRegister: ModuleRegistration.Register = {
    regist: function (appModule: angular.IModule) {
        appModule
            .provider({
                qpMessageDialog: QpMessageDialogProvider
            })
            .component(
                "preferenceEditorComponent", new PreferenceEditorComponent()
            ).service(
                { websiteCurrencyRestService: WebsiteCurrencyRestService }
            )
            .run(["$templateCache", function ($templateCache: angular.ITemplateCacheService) {
                $templateCache.put("preference-editor.tpl", PreferenceEditorTpl);
            }])
            .config(["$accessorProvider", function ($accessorProvider: RestfulAccessorProvider) {
                $accessorProvider.config(WebSiteCurrencyServiceConfig);
            }]).service({
                preferenceEditorService: PreferenceEditorService
            })
    },
}

export { preferenceEditorRegister };